// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"b8282420","84":"ed3b94f5","203":"762f2ab2","716":"1969d39d","764":"56dd179b"}[chunkId] + ".chunk.css";
};